import { GETMY_CASE, APPROVAL_MY_CASE } from "../../actions/types";

const initialState = [];

function mycaseReducer(mycases = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GETMY_CASE:
      return payload;
    case APPROVAL_MY_CASE:
      return mycases.map((mycase) => {
        if (mycase.Case_id === payload.Case_id) {
          return {
            ...mycase,
            ...payload
          };
        } else {
          return mycase;
        }
      })
    default:
      return mycases;
  }
}
export default mycaseReducer;
